export default __webpack_public_path__ + "static/media/xmas-popup-cn.2168ad34.webp";